import { useSyncExternalStore } from 'react';

/**
 * One rule for the layout, the same breakpoints as app.css:
 *   phone   < 700 wide            top bar, tab bar, card lists, bottom sheets
 *   tablet  700–1179 wide         icon rail, tables
 *   desktop ≥ 1180 wide           sidebar, tables, side-by-side map and lists
 */
export type Layout = 'phone' | 'tablet' | 'desktop';

export function layoutFor(width: number): Layout {
  if (width < 700) return 'phone';
  if (width < 1180) return 'tablet';
  return 'desktop';
}

const width = () => (typeof window === 'undefined' ? 1440 : window.innerWidth || 1440);

function subscribe(cb: () => void) {
  if (typeof window === 'undefined') return () => undefined;
  window.addEventListener('resize', cb);
  window.addEventListener('orientationchange', cb);
  return () => {
    window.removeEventListener('resize', cb);
    window.removeEventListener('orientationchange', cb);
  };
}

const snapshot = () => layoutFor(width());

export function useLayout(): Layout {
  return useSyncExternalStore(subscribe, snapshot, () => 'desktop' as Layout);
}

export const useIsPhone = () => useLayout() === 'phone';

/** True when the person asked for less motion (the map glide and the SOS chime pulse respect it). */
export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
}
